import { createApiCall } from 'lib/base';

const FETCH_MARKET_CALENDAR_EDIT_API_ID =
  'DASHBOARD/FETCH_MARKET_CALENDAR_EDIT_API';

const apiCall = createApiCall(
  FETCH_MARKET_CALENDAR_EDIT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/market-calendars/${id}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
